import { History } from 'history';

export const urlGetSearchString = (h: History): string => h.location.search.substring(1);

export const urlReplaceSearchString = (h: History, query: string) => {
  h.replace({ ...h.location, search: query }, h.location.state);
};
